import React from 'react'
import { Heading } from '@chakra-ui/react'

export default (props) => {
  return <Heading {...props} />
}
